import { render, staticRenderFns } from "./notifications-list.vue?vue&type=template&id=2317c974&scoped=true"
import script from "./notifications-list.vue?vue&type=script&lang=js"
export * from "./notifications-list.vue?vue&type=script&lang=js"
import style0 from "./notifications-list.vue?vue&type=style&index=0&id=2317c974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2317c974",
  null
  
)

export default component.exports